(function ($) {
 
	function validateSizeInputDocument(valueSelected) {
		let numberDocument = document.querySelector('.form-item-number-document input');
		switch (valueSelected) {
			case '2':
				numberDocument.setAttribute('maxlength', 10);
				numberDocument.setAttribute('minlength', 4);
				break;
			case '3':
				numberDocument.setAttribute('maxlength', 7);
				numberDocument.setAttribute('minlength', 5);
				break;
			case '4':
				numberDocument.setAttribute('maxlength', 15);
				numberDocument.setAttribute('minlength', 1);
				break;
			case '6':
				numberDocument.setAttribute('maxlength', 11);
				numberDocument.setAttribute('minlength', 9);
				break;
			case '7':
				numberDocument.setAttribute('maxlength', 7);
				numberDocument.setAttribute('minlength', 7);
				break;
			default:
				numberDocument.setAttribute('minlength', 1);
				break;
		}
	}

	function resetInputDocumentNumber(){
		let numberDocument = document.querySelector('.form-item-number-document input');

		if(!numberDocument) return;

		numberDocument.value = '';

	}

	Drupal.behaviors.selectFrontPage = {
		attach: function (context, settings) {

			let formAjax = false;

			if(context === document.querySelector('.data-update-form')){
				formAjax = true;
			}

			if(context === document || formAjax){

				//First step form select
				let selectFirstStep = document.querySelector('.step-1 + .js-form-type-select .form-select');
				let valueSelected = selectFirstStep?.options[selectFirstStep.selectedIndex].value;

				if(!selectFirstStep) return;

				if(valueSelected){
					validateSizeInputDocument(valueSelected);
				}

				selectFirstStep.addEventListener('change', () => {
					let valueOptions = selectFirstStep.options[selectFirstStep.selectedIndex].value;
					let labelError = document.querySelector('.form-item-number-document label.error');
			
					validateSizeInputDocument(valueOptions);
					resetInputDocumentNumber();
			
					if (labelError !== null && labelError.previousElementSibling.value !== "") {
						labelError.parentElement.classList.add('hide-error');
					}
			
				})

			}
		
		}	

	};

})(jQuery);
